<template>
    <b-modal
        v-model="userChoiceNeeded"
        class="user-choice-needed-modal"
        title="Confirm Your Selection"
        size="lg"
        :no-close-on-esc="true"
        :no-close-on-backdrop="true"
        :hide-header-close="true"
        ok-title="Okay"
        ok-variant="orange"
        cancel-title="Cancel"
        @cancel="undo"
        @ok="makeChanges"
    >
        <your-selection />

        <div class="px-4">
            <div
                v-if="conflictResolvingChromeOptions.length > 0"
                class="additions my-3"
            >
                <p>
                    <strong
                        >To {{ isAddition ? "add" : "remove" }} that feature,
                        you must select one of the following options:</strong
                    >
                </p>
                <hr />
                <div class="options">
                    <b-form-radio-group
                        v-model="selectedConflictOption"
                        stacked
                    >
                        <b-form-radio
                            v-for="option in conflictResolvingChromeOptions"
                            :key="option.chromeOptionCode"
                            :value="option"
                        >
                            <div class="label">
                                <!-- eslint-disable-next-line vue/no-v-html -->
                                <span v-html="getName(option)" />
                                <i
                                    v-if="hasDescription(option)"
                                    :id="'popover-' + option.chromeOptionCode"
                                    class="ion-ios-information-outline"
                                    tabindex="-1"
                                    aria-hidden="true"
                                />
                                <b-popover
                                    v-if="hasDescription(option)"
                                    :target="
                                        'popover-' + option.chromeOptionCode
                                    "
                                    triggers="click blur"
                                >
                                    <template slot="title">
                                        <div
                                            class="d-flex justify-content-between"
                                        >
                                            <!-- eslint-disable-next-line vue/no-v-html -->
                                            <div
                                                class="name"
                                                v-html="getName(option)"
                                            />
                                            <div class="cost">
                                                {{
                                                    getCost(option)
                                                        | numeral("$0,0")
                                                }}
                                            </div>
                                        </div>
                                    </template>
                                    <!-- eslint-disable-next-line vue/no-v-html -->
                                    <div
                                        class="description-popover"
                                        v-html="getDescription(option)"
                                    />
                                </b-popover>
                            </div>
                            <div class="cost">
                                {{ getCost(option) | numeral("$0,0") }}
                            </div>
                        </b-form-radio>
                    </b-form-radio-group>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<style lang="scss" scoped>
.user-choice-needed-modal {
    .custom-radio {
        .custom-control-label {
            display: flex;
            justify-content: space-between;
        }
    }

    .cost {
        font-family: $helvetica-55-Roman;
        color: $primary-blue;
        font-size: 16px;
    }
}
.modal-footer {
    button {
        width: 155px !important;
        height: 40px !important;
    }
}
</style>

<script>
import _ from "lodash";
import modals from "Modules/Configure/mixins/modals";
import { get } from "vuex-pathify";
import YourSelection from "Modules/Configure/components/Modal/YourSelection";

export default {
    components: { YourSelection },
    mixins: [modals],

    data() {
        return {
            selectedConflictOption: null
        };
    },

    computed: {
        conflictResolvingChromeOptions: get(
            "configure/conflictResolvingChromeOptions"
        )
    },

    watch: {
        conflictResolvingChromeOptions(newVal) {
            if (_.isNil(newVal) || _.size(newVal) === 0) {
                return;
            }

            this.selectedConflictOption = newVal[0];
        }
    },

    methods: {
        makeChanges() {
            this.onSelect(this.selectedConflictOption);
        }
    }
};
</script>
